export default __webpack_public_path__ + "static/media/halal.39db9077.png";